/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useUserStore from '../../../store/userStore/userStore';

const isUserDuplicate = async (data: {
  email?: string;
  mobile?: string;
}): Promise<any> => {
  const token = useUserStore.getState().userToken;
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (data?.email || data?.mobile) {
    try {
      const response = await axios.request({
        method: CRUDMethods.POST,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.isUserDuplicate}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
};

export default isUserDuplicate;
